import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    shareUrl: String,
    unshareUrl: String
  }
  static targets = ["userSelect", "permissionSelect", "userList"]

  async share() {
    const email = this.userSelectTarget.value
    if (!email) return

    const permission = this.permissionSelectTarget.value
    const body = new FormData()
    body.append("share_email", email)
    body.append("share_permission", permission)

    const html = await this._request(this.shareUrlValue, { method: "POST", body })
    if (html) this._replacePanel(html)
  }

  async unshare(event) {
    const userId = event.currentTarget.dataset.userId
    if (!userId) return

    const body = new FormData()
    body.append("unshare_user_id", userId)

    const html = await this._request(this.unshareUrlValue, { method: "DELETE", body })
    if (html) this._replacePanel(html)
  }

  async _request(url, { method, body }) {
    const token = document.querySelector('meta[name="csrf-token"]')?.content
    const resp = await fetch(url, {
      method,
      headers: {
        "X-CSRF-Token": token,
        "Accept": "text/html"
      },
      body
    })
    if (!resp.ok && resp.status !== 422) return null
    return resp.text()
  }

  _replacePanel(html) {
    const wrapper = this.element
    const temp = document.createElement("div")
    temp.innerHTML = html
    const newPanel = temp.querySelector("#sharing-panel") || temp.firstElementChild
    if (newPanel) {
      wrapper.replaceWith(newPanel)
    }
  }
}
